import React, { useState } from 'react'
import { useHistory } from 'react-router'

import { Badge } from 'react-bootstrap-v5';

export const CrmList = () => {

    const history = useHistory()

    return (

        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="d-flex justify-content-between mb-3">
                            <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div>
                            {/* <div>

                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            width: '200px',
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    placeholder="Search with country..."
                                    value={countryValue}
                                    onChange={(e) => onSelectCountry(e)}
                                    options={countryList}
                                />
                            </div> */}
                            <button className="btn btn-primary w-sm waves-effect waves-light flot-right"
                                onClick={() => history.push('/add-crm')}
                            >Add CRM
                            </button>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Sno.</th>
                                        <th> Customer Name</th>
                                        <th> Mobile No</th>
                                        {/* <th>EMail Address</th>
                                        <th>Inquiry Category</th>
                                        <th> Inquiry Date</th> */}
                                        <th>Quotation No</th>
                                        {/* <th>Quote</th>
                                        <th>Confirmed</th>
                                        <th> Service Name</th> */}
                                        <th>Retailer Name</th>
                                        {/* <th>Value of Goods</th>
                                        <th>Origin</th> */}
                                        <th> Destination</th>
                                        {/* <th> Tentative <br/>Shipping Date</th>
                                        <th>  Item Code</th>
                                        <th>Promocode</th>
                                        <th> Sales Person</th> */}
                                        <th>  Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td>joe</td>
                                        <td>4744612461</td>
                                        <td>joe@gmail.com</td>
                                        <td>inq catrgory</td>
                                        <td>22 May, 2013</td>
                                        <td>889</td>
                                        <td>
                                            <Badge bg="warning " text="dark">
                                                <h6>Pending</h6>
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg="info" text="dark">
                                                <h6>Yes</h6>

                                            </Badge>
                                        </td>
                                        {/* <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>pending</button></td>
                                        <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>Yes</button></td> */}
                                        <td>ServiceName</td>
                                        <td>richel</td>
                                        <td>4267746</td>
                                        <td>Munbai To Dehli</td>
                                        <td>India</td>
                                        <td>3 April, 2021</td>
                                        <td>77</td>
                                        <td>@123</td>
                                        <td>Sanjiv</td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Edit
                                            </button>

                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Delete
                                            </button>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td scope="row">2</td>
                                        <td>joe</td>
                                        <td>4744612461</td>
                                        <td>joe@gmail.com</td>
                                        <td>inq catrgory</td>
                                        <td>22 May, 2013</td>
                                        <td>889</td>
                                        <td>
                                            <Badge bg="success" text="dark">
                                                <h6>Amt</h6>
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg="danger" text="dark">
                                                <h6>No</h6>
                                            </Badge>
                                        </td>
                                        {/* <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>pending</button></td>
                                        <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>Yes</button></td> */}
                                        <td>ServiceName</td>
                                        <td>richel</td>
                                        <td>4267746</td>
                                        <td>Munbai To Dehli</td>

                                        <td>India</td>
                                        <td>3 April, 2021</td>
                                        <td>77</td>
                                        <td>@123</td>
                                        <td>Sanjiv</td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Edit
                                            </button>

                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Delete
                                            </button>
                                        </td>




                                    </tr>
                                    <tr>
                                        <td scope="row">1</td>
                                        <td>joe</td>
                                        <td>4744612461</td>
                                        <td>joe@gmail.com</td>
                                        <td>inq catrgory</td>
                                        <td>22 May, 2013</td>
                                        <td>889</td>
                                        <td>
                                            <Badge bg="warning " text="dark">
                                                <h6>Pending</h6>
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg="info" text="dark">
                                                <h6>Yes</h6>

                                            </Badge>
                                        </td>
                                        {/* <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>pending</button></td>
                                        <td><button className={Active != "true" ? "btn btn-success" : "btn btn-secondary"}>Yes</button></td> */}
                                        <td>ServiceName</td>
                                        <td>richel</td>
                                        <td>4267746</td>
                                        <td>Munbai To Dehli</td>
                                        <td>India</td>
                                        <td>3 April, 2021</td>
                                        <td>77</td>
                                        <td>@123</td>
                                        <td>Sanjiv</td>
                                        <td>
                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Edit
                                            </button>

                                            {/* Button trigger modal */}
                                            <button
                                                type="button"
                                                className="btn btn-danger btn-sm btn-rounded waves-effect waves-light"
                                                onClick={() => history.push('edit-crm')}
                                            >
                                                Delete
                                            </button>
                                        </td>

                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
